export enum AIModel {
    YOLO_V5_OBJECT_DETECTION = 'YOLO_V5_OBJECT_DETECTION',
    SSD_OBJECT_DETECTION = 'SSD_OBJECT_DETECTION',
    POSE_DETECTION = 'POSE_DETECTION'
}
